const uz = {
    meta: {
        title: "Saytga onlayn to'lovni ulash: hujjat, muddat, texnika",
        description:
            "Payme, Click va Uzum'ni saytga ulash: qanday hujjat kerak, ariza necha kunda ko'riladi, dasturchi nima qiladi va komissiya qanday belgilanadi. Amaliy qo'llanma.",
        keywords: [
            "saytga onlayn to'lovni ulash",
            "Payme integratsiya sayt",
            "Click to'lov tizimi ulash",
            "internet ekvayring O'zbekiston",
            "to'lov tizimi API integratsiya",
        ],
    },
    h1: "Payme, Click va Uzum: saytga onlayn to'lovni qanday ulash kerak",
    lead:
        "Onlayn to'lovni ulash ikki qismdan iborat: hujjat va texnika. Hujjat qismi odatda uzoqroq cho'ziladi, texnik qism esa oldindan noto'g'ri rejalashtiriladi. Quyida ikkalasi ham qadamma-qadam.",
    category: "Elektron tijorat",
    readingTime: "9 daqiqa",

    body: [
        {
            type: "p",
            text:
                "«Sayt tayyor, endi to'lovni ulaymiz» — bu jumla loyihalarni eng ko'p kechiktiradigan jumla. To'lov integratsiyasi oxirgi qadam emas: u hujjat yig'ishdan boshlanadi va buyurtma statusi mantig'i bilan tugaydi. Quyida ikkala tomonni ham ochiq yozamiz.",
        },

        { type: "h2", text: "Onlayn to'lov endi nega majburiy bo'lib qoldi?" },
        {
            type: "p",
            text:
                "2025-yil yakuni bo'yicha O'zbekistonda elektron tijorat aylanmasi 22,7 trln so'mga yetdi — oldingi yilga nisbatan 1,5 barobar o'sish. Elektron savdo platformalari soni bir yil ichida 36 tadan 115 taga chiqdi. Xaridor endi kartadan to'lashga o'rgangan va uni «yetkazib berishda naqd» varianti bilan qaytarib bo'lmaydi.",
        },
        {
            type: "p",
            text:
                "Ikkinchi sabab — qonun. Elektron savdoni takomillashtirishga qaratilgan qonun loyihasi 2026-yil 10-fevralda Qonunchilik palatasi tomonidan qabul qilinib, 18-mayda Senat tomonidan ma'qullangan. Unga ko'ra elektron tijorat subyektlari Elektron savdo subyektlari reyestrida ro'yxatdan o'tishi shart. Bu talab to'lov tizimi bilan shartnoma tuzishda hujjat tekshiruvini ham qat'iylashtiradi.",
        },
        {
            type: "p",
            text:
                "Uchinchi sabab amaliy: naqd to'lov qaytarishlarni ko'paytiradi. Kuryer eshik oldida «pulim yo'q ekan» degan javobni eshitadi va tovar omborga qaytadi. Oldindan to'langan buyurtmada bunday yo'qotish deyarli bo'lmaydi.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Ekvayring qanday ishlaydi — qisqa tushuntirish" },
        {
            type: "p",
            text:
                "Internet-ekvayring — saytda karta orqali to'lovni qabul qilish xizmati. Texnik jihatdan zanjirda to'rt ishtirokchi bor: xaridor, sizning saytingiz, to'lov provayderi (Payme, Click yoki Uzum) va bank.",
        },
        {
            type: "p",
            text:
                "Muhim nuqta shunda: pul sizning hisobingizga darhol tushmaydi. Avval summa kartada bloklanadi, keyin sayt to'lovni tasdiqlaydi, so'ng provayder belgilangan jadval bo'yicha hisobingizga o'tkazadi. Shu sababli buyurtma statusini «to'landi» deb belgilash faqat provayderdan tasdiq kelganida amalga oshirilishi kerak.",
        },
        {
            type: "p",
            text:
                "Aynan shu yerda ko'p xato qilinadi. Sayt xaridor to'lov sahifasidan qaytganida buyurtmani «to'landi» deb belgilaydi. Bu noto'g'ri: xaridor to'lamasdan ham qaytishi mumkin. Yagona ishonchli manba — provayderning serverdan serverga yuboradigan xabari.",
        },
        {
            type: "p",
            text:
                "Provayderlar orasidagi farq esa katta emas. Payme, Click va Uzum uchun hujjat to'plami ham, integratsiya mantig'i ham deyarli bir xil. Shuning uchun tanlovni texnika bo'yicha emas, ikki mezon bo'yicha qiling: sizning auditoriyangiz qaysi ilovadan ko'proq foydalanadi va qaysi provayder yaxshiroq tarif taklif qiladi. Amalda ko'p do'konlar kamida ikkitasini birga ulaydi.",
        },

        { type: "h2", text: "Qanday hujjatlar kerak va ariza necha kunda ko'riladi?" },
        {
            type: "p",
            text:
                "Har bir provayderning o'z anketasi bor, lekin talablar yadrosi bir xil. Jismoniy shaxs sifatida ekvayring ulanmaydi — biznes rasmiylashtirilgan bo'lishi shart.",
        },
        {
            type: "list",
            items: [
                "Yuridik shaxs yoki yakka tartibdagi tadbirkor sifatida ro'yxatdan o'tganlik guvohnomasi.",
                "STIR va rahbar pasporti nusxasi; yuridik shaxsda — ustav va tayinlash to'g'risidagi buyruq.",
                "Bank hisob raqami rekvizitlari — pul aynan shu hisobga tushadi.",
                "Faoliyat turi (OKED) savdoga mos bo'lishi kerak. Nomuvofiqlik — rad javobining eng tez-tez uchraydigan sababi.",
                "Ishlayotgan sayt: katalog, narxlar, ommaviy oferta, qaytarish shartlari, yetkazib berish qoidalari va aloqa ma'lumotlari.",
            ],
        },
        {
            type: "p",
            text:
                "Oxirgi band alohida e'tibor talab qiladi. Provayder saytni odam ko'zi bilan tekshiradi. Agar oferta va qaytarish sahifalari bo'lmasa, ariza texnik sabab bilan emas, kontent sababi bilan qaytariladi va butun jarayon boshidan boshlanadi.",
        },
        {
            type: "table",
            head: ["Bosqich", "Kim bajaradi", "Odatiy muddat"],
            rows: [
                ["Hujjat yig'ish va anketa", "Biznes", "2–5 ish kuni"],
                ["Arizani ko'rib chiqish", "To'lov provayderi", "3–10 ish kuni"],
                ["Shartnoma va tarif kelishuvi", "Biznes va provayder", "2–5 ish kuni"],
                ["Test kalitlari va integratsiya", "Dasturchi", "3–7 ish kuni"],
                ["Test rejimida tekshirish", "Provayder va dasturchi", "1–3 ish kuni"],
                ["Jonli rejimga o'tkazish", "Provayder", "1–2 ish kuni"],
            ],
        },
        {
            type: "p",
            text:
                "Jami real muddat — ikki haftadan bir oygacha. Saytni ishga tushirish sanasini shu muddatni hisobga olib belgilang. Amaliyotimizda hujjat yig'ishni sayt qurilishi bilan parallel boshlagan loyihalar bir oyga tezroq ishga tushadi.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Dasturchi tomonida aniq nima qilinadi?" },
        {
            type: "p",
            text:
                "Rahbar dasturchiga nima buyurtma berayotganini bilishi kerak. «Payme'ni ulang» — bu texnik topshiriq emas. To'liq ish quyidagi bandlardan iborat.",
        },
        {
            type: "ol",
            items: [
                "To'lov yaratish: sayt buyurtma summasi va identifikatorini provayderga uzatadi va to'lov havolasini oladi.",
                "Webhook qabul qilish: provayder serverga to'lov holati haqida xabar yuboradi, sayt uni qabul qilib javob qaytaradi.",
                "Idempotentlik: bitta xabar ikki marta kelsa, buyurtma ikki marta to'langan deb belgilanmasligi kerak.",
                "Bekor qilish va qaytarish: to'lovni qisman yoki to'liq qaytarish stsenariysi oldindan yozilishi shart.",
                "Buyurtma statuslari: kutilmoqda, to'landi, bekor qilindi, qaytarildi — har biri admin panelda ko'rinadi.",
                "Jurnal: har bir so'rov va javob yozib boriladi. Nizo chiqqanda yagona dalil shu.",
            ],
        },
        {
            type: "p",
            text:
                "Alohida eslatma: to'lov summasini serverda hisoblang, brauzerda emas. Aks holda xaridor sahifa kodida summani o'zgartirib, tovarni arzonga olib ketishi mumkin. Bu nazariy xavf emas, amalda uchraydigan xato.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Test rejimidan jonli rejimga qanday o'tiladi?" },
        {
            type: "p",
            text:
                "Provayder avval test kalitlarini beradi. Test rejimida haqiqiy pul harakatlanmaydi, lekin barcha stsenariylarni tekshirib olish kerak: muvaffaqiyatli to'lov, mablag' yetmasligi, xaridor to'lovni yarmida tashlab ketishi, qaytarish.",
        },
        {
            type: "p",
            text:
                "Jonli rejimga o'tgach, birinchi to'lovni o'z kartangiz bilan kichik summaga qiling va pul hisobga qachon tushishini o'lchang. Bu raqamni bilish keyin muhim bo'ladi: kuryerga pul berish jadvalini shunga qarab tuzasiz.",
        },
        {
            type: "p",
            text:
                "Yana bir bosqich ko'pincha unutiladi — buxgalteriya bilan bog'lash. To'lov tushgan har bir buyurtma chek va elektron hisob-faktura bilan yakunlanishi kerak. O'zbekistonda ESF majburiy va 2026-yilda uning avtomatik nazorati kuchaytirildi. Shu sababli to'lovni ulash bilan bir vaqtda buxgalteringiz bilan hisobot oqimini kelishib oling.",
        },
        {
            type: "callout",
            text:
                "Jonli rejimga o'tishdan oldin qaytarish stsenariysini albatta sinab ko'ring. Ko'p do'konlar qaytarishni birinchi real nizo chiqqanida yozishni boshlaydi — bu eng yomon vaqt.",
        },

        { type: "h2", text: "Komissiya qancha bo'ladi?" },
        {
            type: "p",
            text:
                "Bu yerda ochiq javob beramiz: Payme, Click va Uzum'ning internet-ekvayring bo'yicha ochiq tarif jadvali mavjud emas. Internetda uchraydigan aniq foizlar rasmiy manbaga tayanmaydi va biz ularni takrorlamaymiz.",
        },
        {
            type: "p",
            text:
                "Amalda tarif shartnomada individual belgilanadi va u sizning oylik aylanmangizga, tovar toifangizga hamda qaytarishlar ulushiga bog'liq bo'ladi. Aylanma o'sganda tarifni qayta ko'rib chiqishni so'rash mumkin — bu odatiy amaliyot.",
        },
        {
            type: "p",
            text:
                "Shartnoma imzolashdan oldin uchta narsani yozma so'rang: stavkaning o'zi, pul hisobga tushish jadvali va qaytarish bo'yicha komissiya qanday hisoblanishi. Uchinchi band ko'pincha e'tibordan chetda qoladi va keyin kutilmagan xarajat bo'lib chiqadi.",
        },

        { type: "h2", text: "Integratsiya qancha turadi va qachon o'zini oqlaydi?" },
        {
            type: "p",
            text:
                "Innobek'da ishlaydigan internet-do'kon 16 000 000 so'mdan boshlanadi va bu narxga Payme hamda Click integratsiyasi allaqachon kiritilgan. Mavjud saytga to'lovni alohida ulash — kichikroq ish, lekin u saytning texnik holatiga qarab juda farq qiladi.",
        },
        {
            type: "p",
            text:
                "Narxga kirmaydigan narsa — ekvayring komissiyasining o'zi. U provayderga to'lanadi va ishlab chiqish byudjetiga aloqasi yo'q. Buni loyiha boshida ajratib aytamiz, chunki ko'pchilik ikkalasini bitta summa deb o'ylaydi.",
        },
        {
            type: "p",
            text:
                "Qaytim hisobini o'zingiz chiqaring. Oyiga 200 buyurtma va o'rtacha chek 300 000 so'm bo'lsin — bu 60 mln so'm aylanma. Naqd to'lovda buyurtmalarning 10% i eshik oldida rad etilsa, oyiga 6 mln so'm aylanma yo'qoladi. Oldindan to'lov shu yo'qotishning katta qismini to'xtatadi.",
        },
        {
            type: "p",
            text:
                "Shu misolda integratsiya bir-ikki oyda qaytadi. Lekin buni va'da deb emas, formula deb qabul qiling: o'z rad etish foizingizni oling va o'z chekingizga ko'paytiring.",
        },

        { type: "h2", text: "Onlayn to'lovsiz qolishning narxi nimada?" },
        {
            type: "p",
            text:
                "Bu bandni hisoblash oson, chunki yo'qotishlar bevosita ko'rinadi.",
        },
        {
            type: "list",
            items: [
                "Eshik oldidagi rad etishlar: kuryer vaqti, yoqilg'i va tovarning qayta joylanishi — hammasi zarar.",
                "Tashlab ketilgan savatlar: xaridor karta bilan to'lay olmasa, ko'pincha umuman buyurtma bermaydi.",
                "Naqd pul aylanmasi: inkassatsiya, hisobga topshirish va nazorat qo'shimcha mehnat talab qiladi.",
                "Hisobot: elektron hisob-faktura majburiy va 2026-yilda avtomatik nazorat kuchaytirildi — naqd oqim buni qiyinlashtiradi.",
                "Reklama samarasi: to'lovsiz saytda konversiyani aniq o'lchab bo'lmaydi, demak reklama byudjeti ko'r-ko'rona sarflanadi.",
            ],
        },

        { type: "h2", text: "Qachon to'lov integratsiyasi shoshilinch emas?" },
        {
            type: "p",
            text:
                "To'lov har bir biznesga bir xil shoshilinch emas. Quyidagi holatlarda biz avval boshqa narsaga byudjet ajratishni tavsiya qilamiz.",
        },
        {
            type: "list",
            items: [
                "Oyiga 20 tadan kam buyurtma. Bunday hajmda to'lovni menejer havola orqali ham qabul qila oladi.",
                "Savdo B2B va to'lovlar shartnoma asosida bank o'tkazmasi bilan ketadi — ekvayring bu yerda ortiqcha.",
                "Tovar narxi har buyurtmada alohida kelishiladi. Qat'iy summa bo'lmaguncha standart integratsiya ishlamaydi.",
                "Biznes hali rasmiylashtirilmagan. Hujjatsiz ariza baribir qabul qilinmaydi.",
                "Sayt hali oferta va qaytarish sahifalarisiz. Avval shu sahifalarni tayyorlang, keyin ariza bering.",
            ],
        },
        { type: "image", image: 3 },
        {
            type: "p",
            text:
                "Qolgan barcha holatlarda to'lovni sayt ishga tushishi bilan bir vaqtda rejalashtirish kerak. Keyin qo'shish qimmatroq tushadi: buyurtma mantig'i va admin panel qayta yoziladi.",
        },
    ],

    faq: [
        {
            q: "Onlayn to'lovni ulash uchun qanday hujjatlar kerak?",
            a: "Kerak bo'ladi: yuridik shaxs yoki yakka tartibdagi tadbirkor guvohnomasi, STIR, rahbar pasporti nusxasi, bank hisob raqami rekvizitlari va savdoga mos faoliyat turi. Bundan tashqari sayt ishlayotgan bo'lishi, unda ommaviy oferta, qaytarish shartlari, yetkazib berish qoidalari va aloqa ma'lumotlari joylashgan bo'lishi shart. Jismoniy shaxsga ekvayring ulanmaydi.",
        },
        {
            q: "Ariza ko'rib chiqish va ulash qancha vaqt oladi?",
            a: "Hujjat yig'ishga odatda 2–5 ish kuni, arizani ko'rib chiqishga 3–10 ish kuni, shartnoma va tarif kelishuviga yana 2–5 kun ketadi. Texnik integratsiya va test 4–10 kunni oladi. Jami real muddat ikki haftadan bir oygacha. Hujjat yig'ishni sayt qurilishi bilan parallel boshlasangiz, ishga tushish sezilarli tezlashadi.",
        },
        {
            q: "Payme va Click komissiyasi necha foiz?",
            a: "Ochiq tarif jadvali e'lon qilinmaydi. Tarif shartnomada individual belgilanadi va oylik aylanmangizga, tovar toifangizga hamda qaytarishlar ulushiga bog'liq bo'ladi. Boshqa saytlarda uchraydigan aniq foizlar rasmiy manbaga tayanmaydi, shuning uchun ularni byudjet asosi qilib olmang. Shartnomadan oldin stavkani, pul hisobga tushish jadvalini va qaytarish bo'yicha komissiya qanday hisoblanishini yozma ko'rinishda so'rang.",
        },
        {
            q: "Dasturchi tomonida qanday ishlar bajariladi?",
            a: "To'lov yaratish so'rovi, webhook qabul qilish, takroriy xabarlardan himoya, bekor qilish va qaytarish stsenariysi, buyurtma statuslari hamda so'rovlar jurnali. Alohida talab — summani serverda hisoblash. Agar summa brauzerda hisoblansa, xaridor uni o'zgartirib tovarni arzonga olib ketishi mumkin. Bu amalda uchraydigan xato.",
        },
        {
            q: "Pul hisobimga qachon tushadi?",
            a: "Darhol emas. Avval summa kartada bloklanadi, keyin sayt to'lovni tasdiqlaydi, so'ng provayder shartnomada belgilangan jadval bo'yicha hisobingizga o'tkazadi. Jadval har bir provayder va tarifda farq qiladi, shuning uchun uni shartnomadan aniq biling. Kuryer va yetkazib berish to'lovlarini shu jadvalga moslab rejalashtiring.",
        },
        {
            q: "Naqd to'lov variantini qoldirish kerakmi?",
            a: "Ha, hozircha kerak. Auditoriyaning sezilarli qismi hali ham yetkazib berishda naqd to'lashni afzal ko'radi va bu variantni o'chirish buyurtma sonini kamaytiradi. To'g'ri yechim — ikkalasini birga qoldirish, lekin oldindan to'lovni chegirma yoki bepul yetkazib berish bilan rag'batlantirish. Shunda rad etishlar asta kamayadi.",
        },
    ],

    cta: {
        h: "To'lovni saytingizga ulab beramiz",
        p: "Saytingiz qanday platformada qurilganini ayting — integratsiya hajmi, muddati va hujjat ro'yxatini bepul baholab beramiz.",
        button: "Baholashni so'rash",
    },

    images: [
        {
            src: "/assets/img/blog/ecom-checkout.webp",
            alt: "Mobil qurilmada to'lov usulini tanlash ekrani",
            caption: "Checkout — do'konning eng ko'p pul yo'qotadigan ekrani",
            prompt:
                "Mobile checkout screen mockup held in a hand: payment method selection with three neutral unbranded card-payment tiles, total amount field and a pay button; clean e-commerce UI, blue accent, soft studio background, no real brand logos, 16:9",
        },
        {
            src: "/assets/img/blog/ecom-payment-flow.webp",
            alt: "Onlayn to'lovning texnik ketma-ketligi: ariza, webhook va buyurtma statusi",
            caption: "To'lov oqimi: so'rov, provayder javobi, webhook va status yangilanishi",
            prompt:
                "Sequence diagram of an online payment: customer -> store backend -> payment provider -> bank -> webhook callback -> order status update, with a side branch for refund and cancellation; clean technical line diagram, monochrome with blue highlights, numbered steps, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/blog/ecom-documents.webp",
            alt: "Ekvayring shartnomasi uchun kerak bo'ladigan hujjatlar to'plami",
            caption: "Vaqtning katta qismi aynan hujjat yig'ishga ketadi",
            prompt:
                "Document checklist illustration: a folder with company registration certificate, tax ID paper, bank account statement and a signed contract, arranged flat-lay on a desk; clean editorial photography style, neutral colours, no readable text, 4:3",
        },
        {
            src: "/assets/img/projects/besh-market-app.webp",
            alt: "Besh Market ilovasi — savat va to'lov bosqichi",
            caption: "Besh Market — to'lov ulangan savdo ilovasi",
        },
    ],

    relatedServices: ["internet-dokonlar", "veb-ilovalar", "telegram-bot"],
    relatedPosts: ["marketpleys-yoki-oz-internet-dokon", "internet-dokon-qonuniy-talablar-2026", "internetdokon"],
};

const ru = {
    meta: {
        title: "Подключение онлайн-оплаты на сайт: документы и сроки",
        description:
            "Payme, Click и Uzum на сайте: какие документы нужны, сколько рассматривают заявку, что делает разработчик и как определяется комиссия. Практическое руководство.",
        keywords: [
            "подключить онлайн-оплату на сайт Узбекистан",
            "интернет-эквайринг Узбекистан подключение",
            "интеграция Payme API",
            "Click merchant подключение документы",
            "приём оплаты картой на сайте",
        ],
    },
    h1: "Payme, Click и Uzum: как подключить онлайн-оплату к сайту",
    lead:
        "Подключение онлайн-оплаты состоит из двух частей: документы и техника. Документы обычно занимают больше времени, а техническую часть чаще всего планируют неверно. Ниже разобраны обе — по шагам.",
    category: "Электронная коммерция",
    readingTime: "9 минут",

    body: [
        {
            type: "p",
            text:
                "«Сайт готов, теперь подключим оплату» — фраза, которая чаще всего сдвигает сроки проекта. Платёжная интеграция — не последний шаг: она начинается со сбора документов и заканчивается логикой статусов заказа. Ниже мы описываем обе стороны без упрощений.",
        },

        { type: "h2", text: "Почему онлайн-оплата стала обязательной?" },
        {
            type: "p",
            text:
                "По итогам 2025 года оборот электронной коммерции в Узбекистане достиг 22,7 трлн сум — рост в 1,5 раза к предыдущему году. Число электронных торговых платформ за год выросло с 36 до 115. Покупатель привык платить картой, и вернуть его к варианту «наличными курьеру» уже не получится.",
        },
        {
            type: "p",
            text:
                "Вторая причина — закон. Законопроект о совершенствовании электронной торговли принят Законодательной палатой 10 февраля 2026 года и одобрен Сенатом 18 мая. Субъекты электронной коммерции обязаны регистрироваться в Реестре субъектов электронной торговли. Это требование ужесточает и проверку документов при заключении договора с платёжной системой.",
        },
        {
            type: "p",
            text:
                "Третья причина практическая: наличная оплата увеличивает число отказов. Курьер слышит у двери «денег не оказалось», и товар возвращается на склад. При предоплате таких потерь почти не бывает.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Как устроен эквайринг — коротко" },
        {
            type: "p",
            text:
                "Интернет-эквайринг — это приём оплаты картой на сайте. Технически в цепочке четыре участника: покупатель, ваш сайт, платёжный провайдер (Payme, Click или Uzum) и банк.",
        },
        {
            type: "p",
            text:
                "Важный момент: деньги не поступают на ваш счёт мгновенно. Сначала сумма блокируется на карте, затем сайт подтверждает платёж, и только после этого провайдер переводит средства по установленному графику. Поэтому помечать заказ как оплаченный можно лишь после подтверждения от провайдера.",
        },
        {
            type: "p",
            text:
                "Именно здесь чаще всего ошибаются. Сайт ставит статус «оплачено» в момент, когда покупатель вернулся со страницы оплаты. Это неверно: вернуться можно и не заплатив. Единственный надёжный источник — сообщение, которое провайдер отправляет с сервера на сервер.",
        },
        {
            type: "p",
            text:
                "Разница между провайдерами при этом невелика. У Payme, Click и Uzum почти одинаковы и пакет документов, и логика интеграции. Поэтому выбирать стоит не по технике, а по двум критериям: каким приложением чаще пользуется ваша аудитория и кто предложит лучший тариф. На практике большинство магазинов подключает минимум два способа сразу.",
        },

        { type: "h2", text: "Какие документы нужны и сколько рассматривают заявку?" },
        {
            type: "p",
            text:
                "У каждого провайдера своя анкета, но ядро требований совпадает. Физическому лицу эквайринг не подключают — бизнес должен быть оформлен.",
        },
        {
            type: "list",
            items: [
                "Свидетельство о регистрации юридического лица или индивидуального предпринимателя.",
                "ИНН и копия паспорта руководителя; для юрлица — устав и приказ о назначении.",
                "Реквизиты банковского счёта — деньги будут приходить именно на него.",
                "Вид деятельности (ОКЭД) должен соответствовать торговле. Несоответствие — самая частая причина отказа.",
                "Работающий сайт: каталог, цены, публичная оферта, условия возврата, правила доставки и контакты.",
            ],
        },
        {
            type: "p",
            text:
                "Последний пункт требует отдельного внимания. Провайдер проверяет сайт глазами человека. Если страниц оферты и возврата нет, заявку отклонят не по технической, а по контентной причине — и весь процесс придётся начинать заново.",
        },
        {
            type: "table",
            head: ["Этап", "Кто выполняет", "Типичный срок"],
            rows: [
                ["Сбор документов и анкета", "Бизнес", "2–5 рабочих дней"],
                ["Рассмотрение заявки", "Платёжный провайдер", "3–10 рабочих дней"],
                ["Договор и согласование тарифа", "Бизнес и провайдер", "2–5 рабочих дней"],
                ["Тестовые ключи и интеграция", "Разработчик", "3–7 рабочих дней"],
                ["Проверка в тестовом режиме", "Провайдер и разработчик", "1–3 рабочих дня"],
                ["Перевод в боевой режим", "Провайдер", "1–2 рабочих дня"],
            ],
        },
        {
            type: "p",
            text:
                "Итоговый реальный срок — от двух недель до месяца. Дату запуска сайта назначайте с учётом этого интервала. В нашей практике проекты, где документы собирают параллельно с разработкой, запускаются на месяц раньше.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Что именно делает разработчик?" },
        {
            type: "p",
            text:
                "Руководителю нужно понимать, что он заказывает. «Подключите Payme» — это не техническое задание. Полный объём работ состоит из следующих пунктов.",
        },
        {
            type: "ol",
            items: [
                "Создание платежа: сайт передаёт провайдеру сумму и идентификатор заказа, получает платёжную ссылку.",
                "Приём webhook: провайдер сообщает серверу о статусе платежа, сайт принимает сообщение и отвечает.",
                "Идемпотентность: если одно и то же сообщение придёт дважды, заказ не должен считаться оплаченным дважды.",
                "Отмена и возврат: сценарий частичного и полного возврата пишется заранее, а не по факту спора.",
                "Статусы заказа: ожидает оплаты, оплачен, отменён, возвращён — каждый виден в админ-панели.",
                "Журнал: каждый запрос и ответ логируются. При споре это единственное доказательство.",
            ],
        },
        {
            type: "p",
            text:
                "Отдельное предупреждение: сумму платежа считайте на сервере, а не в браузере. Иначе покупатель изменит её в коде страницы и заберёт товар дешевле. Это не теоретический риск, а ошибка, которая встречается на практике.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Как перейти из тестового режима в боевой?" },
        {
            type: "p",
            text:
                "Сначала провайдер выдаёт тестовые ключи. В тестовом режиме реальные деньги не двигаются, но проверить нужно все сценарии: успешную оплату, нехватку средств, уход покупателя посреди оплаты и возврат.",
        },
        {
            type: "p",
            text:
                "После перехода в боевой режим проведите первый платёж своей картой на небольшую сумму и замерьте, когда деньги окажутся на счёте. Эта цифра пригодится: по ней вы построите график расчётов с курьерской службой и поставщиками.",
        },
        {
            type: "p",
            text:
                "Ещё один шаг забывают чаще остальных — связку с бухгалтерией. Каждый оплаченный заказ должен закрываться чеком и электронным счётом-фактурой. В Узбекистане ЭСФ обязателен, а в 2026 году автоматический контроль по нему усилен. Поэтому согласуйте поток отчётности с бухгалтером одновременно с подключением оплаты, а не через квартал.",
        },
        {
            type: "callout",
            text:
                "Перед боевым запуском обязательно протестируйте возврат. Многие магазины начинают писать этот сценарий в момент первого реального спора — худшее возможное время.",
        },

        { type: "h2", text: "Какой будет комиссия?" },
        {
            type: "p",
            text:
                "Отвечаем честно: открытой тарифной сетки по интернет-эквайрингу у Payme, Click и Uzum нет. Конкретные проценты, которые встречаются в интернете, не опираются на официальный источник, и мы их не повторяем.",
        },
        {
            type: "p",
            text:
                "На практике тариф определяется в договоре индивидуально и зависит от вашего месячного оборота, товарной категории и доли возвратов. При росте оборота ставку можно попросить пересмотреть — это обычная практика рынка.",
        },
        {
            type: "p",
            text:
                "До подписания договора запросите письменно три вещи: саму ставку, график поступления денег на счёт и порядок начисления комиссии при возврате. Третий пункт чаще всего упускают, и позже он оказывается неожиданной статьёй расходов.",
        },

        { type: "h2", text: "Сколько стоит интеграция и когда она окупается?" },
        {
            type: "p",
            text:
                "В Innobek работающий интернет-магазин начинается от 16 000 000 сум, и интеграция Payme и Click уже входит в эту цену. Подключение оплаты к существующему сайту — работа меньшего объёма, но её стоимость сильно зависит от технического состояния сайта.",
        },
        {
            type: "p",
            text:
                "В цену не входит сама комиссия эквайринга. Она платится провайдеру и к бюджету разработки отношения не имеет. Мы отделяем это в начале проекта, потому что многие воспринимают обе суммы как одну.",
        },
        {
            type: "p",
            text:
                "Окупаемость посчитайте сами. Допустим, 200 заказов в месяц при среднем чеке 300 000 сум — оборот 60 млн сум. Если при наличной оплате 10% заказов срываются у двери, вы теряете 6 млн сум оборота в месяц. Предоплата снимает бо́льшую часть этой потери.",
        },
        {
            type: "p",
            text:
                "В этом примере интеграция окупается за один-два месяца. Но воспринимайте это не как обещание, а как формулу: подставьте свой процент срывов и свой средний чек.",
        },

        { type: "h2", text: "В чём цена работы без онлайн-оплаты?" },
        {
            type: "p",
            text:
                "Эту статью посчитать несложно, потому что потери видны напрямую.",
        },
        {
            type: "list",
            items: [
                "Отказы у двери: время курьера, топливо и повторное размещение товара — всё это прямой убыток.",
                "Брошенные корзины: если заплатить картой нельзя, покупатель чаще просто не оформляет заказ.",
                "Наличный оборот: инкассация, сдача в кассу и контроль требуют дополнительного труда.",
                "Отчётность: электронный счёт-фактура обязателен, а в 2026 году автоматический контроль усилен — наличный поток это усложняет.",
                "Эффективность рекламы: без оплаты на сайте конверсию не измерить точно, значит, бюджет расходуется вслепую.",
            ],
        },

        { type: "h2", text: "Когда подключение оплаты не срочно?" },
        {
            type: "p",
            text:
                "Срочность у разных бизнесов разная. В перечисленных ниже случаях мы советуем сначала направить бюджет на другое.",
        },
        {
            type: "list",
            items: [
                "Меньше 20 заказов в месяц. При таком объёме менеджер принимает оплату по разовой ссылке.",
                "Продажи идут в B2B и оплачиваются банковским переводом по договору — эквайринг здесь лишний.",
                "Цена согласуется индивидуально по каждому заказу. Пока нет фиксированной суммы, стандартная интеграция не работает.",
                "Бизнес ещё не оформлен. Без документов заявку всё равно не примут.",
                "На сайте нет оферты и условий возврата. Сначала подготовьте эти страницы, потом подавайте заявку.",
            ],
        },
        { type: "image", image: 3 },
        {
            type: "p",
            text:
                "Во всех остальных случаях оплату планируют одновременно с запуском сайта. Добавлять её позже дороже: логику заказа и админ-панель приходится переписывать.",
        },
    ],

    faq: [
        {
            q: "Какие документы нужны для подключения онлайн-оплаты?",
            a: "Понадобятся свидетельство о регистрации юрлица или ИП, ИНН, копия паспорта руководителя, реквизиты банковского счёта и вид деятельности по ОКЭД, соответствующий торговле. Кроме того, сайт должен работать и содержать публичную оферту, условия возврата, правила доставки и контактные данные компании. Физическому лицу интернет-эквайринг не подключают: бизнес обязательно должен быть оформлен.",
        },
        {
            q: "Сколько времени занимает рассмотрение и подключение?",
            a: "На сбор документов обычно уходит 2–5 рабочих дней, на рассмотрение заявки 3–10 дней, на договор и согласование тарифа ещё 2–5 дней. Техническая интеграция и тестирование занимают 4–10 дней. Итого реальный срок — от двух недель до месяца. Параллельный сбор документов во время разработки заметно ускоряет запуск.",
        },
        {
            q: "Какой процент комиссии у Payme и Click?",
            a: "Открытая тарифная сетка не публикуется. Тариф определяется в договоре индивидуально и зависит от месячного оборота, товарной категории и доли возвратов. Конкретные проценты с других сайтов не подтверждены официальным источником. До подписания запросите письменно ставку, график поступления денег и комиссию при возврате.",
        },
        {
            q: "Что входит в работу разработчика?",
            a: "Запрос на создание платежа, приём webhook, защита от повторных сообщений, сценарии отмены и возврата, статусы заказа и журнал запросов. Отдельное требование — считать сумму на сервере. Если сумма считается в браузере, покупатель может изменить её и забрать товар дешевле. Такая ошибка встречается на практике.",
        },
        {
            q: "Когда деньги поступят на счёт?",
            a: "Не сразу. Сначала сумма блокируется на карте, затем сайт подтверждает платёж, и только после этого провайдер переводит средства по графику, указанному в договоре. График различается у разных провайдеров и тарифов, поэтому уточните его до подписания. Расчёты с курьерской службой планируйте под этот график.",
        },
        {
            q: "Нужно ли оставлять оплату наличными?",
            a: "Да, пока нужно. Заметная часть аудитории всё ещё предпочитает платить курьеру наличными, и отключение этого варианта снизит число заказов. Правильное решение — оставить оба способа, но поощрять предоплату скидкой или бесплатной доставкой. Тогда доля отказов у двери будет постепенно снижаться.",
        },
    ],

    cta: {
        h: "Подключим оплату к вашему сайту",
        p: "Расскажите, на какой платформе сделан сайт — бесплатно оценим объём интеграции, сроки и подготовим список документов.",
        button: "Запросить оценку",
    },

    images: [
        {
            src: "/assets/img/blog/ecom-checkout.webp",
            alt: "Экран выбора способа оплаты на мобильном устройстве",
            caption: "Checkout — экран, на котором магазин теряет больше всего денег",
            prompt:
                "Mobile checkout screen mockup held in a hand: payment method selection with three neutral unbranded card-payment tiles, total amount field and a pay button; clean e-commerce UI, blue accent, soft studio background, no real brand logos, 16:9",
        },
        {
            src: "/assets/img/blog/ecom-payment-flow.webp",
            alt: "Техническая последовательность онлайн-платежа: запрос, webhook и статус заказа",
            caption: "Поток платежа: запрос, ответ провайдера, webhook и обновление статуса",
            prompt:
                "Sequence diagram of an online payment: customer -> store backend -> payment provider -> bank -> webhook callback -> order status update, with a side branch for refund and cancellation; clean technical line diagram, monochrome with blue highlights, numbered steps, no text placeholders, 16:9",
        },
        {
            src: "/assets/img/blog/ecom-documents.webp",
            alt: "Комплект документов для договора эквайринга",
            caption: "Большая часть времени уходит именно на сбор документов",
            prompt:
                "Document checklist illustration: a folder with company registration certificate, tax ID paper, bank account statement and a signed contract, arranged flat-lay on a desk; clean editorial photography style, neutral colours, no readable text, 4:3",
        },
        {
            src: "/assets/img/projects/besh-market-app.webp",
            alt: "Приложение Besh Market — корзина и этап оплаты",
            caption: "Besh Market — торговое приложение с подключённой оплатой",
        },
    ],

    relatedServices: ["internet-dokonlar", "veb-ilovalar", "telegram-bot"],
    relatedPosts: ["marketpleys-yoki-oz-internet-dokon", "internet-dokon-qonuniy-talablar-2026", "internetdokon"],
};

const content = { uz, ru };

export default content;
